import { render } from "./SimpleNotes.vue?vue&type=template&id=fe48e08a&scoped=true"
import script from "./SimpleNotes.vue?vue&type=script&lang=js"
export * from "./SimpleNotes.vue?vue&type=script&lang=js"

import "./SimpleNotes.vue?vue&type=style&index=0&id=fe48e08a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe48e08a"]])

export default __exports__